// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as AgentRouteImport } from './routes/agent'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as InterimManagementRouteImport } from './routes/interim-management'
import { Route as LibertyRouteImport } from './routes/liberty'
import { Route as MarketingSalesRouteImport } from './routes/marketing-sales'
import { Route as OctopusRouteImport } from './routes/octopus'
import { Route as PersonaFiRouteImport } from './routes/personaFi'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ResearcherRouteImport } from './routes/researcher'
import { Route as AdminWebVitalsRouteImport } from './routes/admin/web-vitals'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as ByIndexRouteImport } from './routes/by/index'
import { Route as ByAboutUsRouteImport } from './routes/by/about-us'
import { Route as ByAgentRouteImport } from './routes/by/agent'
import { Route as ByContactRouteImport } from './routes/by/contact'
import { Route as ByCookiePolicyRouteImport } from './routes/by/cookie-policy'
import { Route as ByInterimManagementRouteImport } from './routes/by/interim-management'
import { Route as ByLibertyRouteImport } from './routes/by/liberty'
import { Route as ByMarketingSalesRouteImport } from './routes/by/marketing-sales'
import { Route as ByOctopusRouteImport } from './routes/by/octopus'
import { Route as ByPersonaFiRouteImport } from './routes/by/personaFi'
import { Route as ByPrivacyPolicyRouteImport } from './routes/by/privacy-policy'
import { Route as ByResearcherRouteImport } from './routes/by/researcher'
import { Route as CaseStudiesSpotlessPolskaRouteImport } from './routes/case-studies.spotless-polska'
import { Route as PersonaFiAgentRouteImport } from './routes/personaFi/agent'
import { Route as PlIndexRouteImport } from './routes/pl/index'
import { Route as PlAboutUsRouteImport } from './routes/pl/about-us'
import { Route as PlAgentRouteImport } from './routes/pl/agent'
import { Route as PlContactRouteImport } from './routes/pl/contact'
import { Route as PlCookiePolicyRouteImport } from './routes/pl/cookie-policy'
import { Route as PlInterimManagementRouteImport } from './routes/pl/interim-management'
import { Route as PlLibertyRouteImport } from './routes/pl/liberty'
import { Route as PlMarketingSalesRouteImport } from './routes/pl/marketing-sales'
import { Route as PlOctopusRouteImport } from './routes/pl/octopus'
import { Route as PlPersonaFiRouteImport } from './routes/pl/personaFi'
import { Route as PlPrivacyPolicyRouteImport } from './routes/pl/privacy-policy'
import { Route as PlResearcherRouteImport } from './routes/pl/researcher'
import { Route as ByBlogIndexRouteImport } from './routes/by/blog/index'
import { Route as ByBlogSlugRouteImport } from './routes/by/blog/$slug'
import { Route as ByCaseStudiesSpotlessPolskaRouteImport } from './routes/by/case-studies.spotless-polska'
import { Route as ByPersonaFiAgentRouteImport } from './routes/by/personaFi/agent'
import { Route as PlBlogIndexRouteImport } from './routes/pl/blog/index'
import { Route as PlBlogSlugRouteImport } from './routes/pl/blog/$slug'
import { Route as PlCaseStudiesSpotlessPolskaRouteImport } from './routes/pl/case-studies.spotless-polska'
import { Route as PlPersonaFiAgentRouteImport } from './routes/pl/personaFi/agent'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const AgentRoute = AgentRouteImport.update({
            id: '/agent',path: '/agent',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiePolicyRoute = CookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => rootRouteImport
          })
const InterimManagementRoute = InterimManagementRouteImport.update({
            id: '/interim-management',path: '/interim-management',getParentRoute: () => rootRouteImport
          })
const LibertyRoute = LibertyRouteImport.update({
            id: '/liberty',path: '/liberty',getParentRoute: () => rootRouteImport
          })
const MarketingSalesRoute = MarketingSalesRouteImport.update({
            id: '/marketing-sales',path: '/marketing-sales',getParentRoute: () => rootRouteImport
          })
const OctopusRoute = OctopusRouteImport.update({
            id: '/octopus',path: '/octopus',getParentRoute: () => rootRouteImport
          })
const PersonaFiRoute = PersonaFiRouteImport.update({
            id: '/personaFi',path: '/personaFi',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ResearcherRoute = ResearcherRouteImport.update({
            id: '/researcher',path: '/researcher',getParentRoute: () => rootRouteImport
          })
const AdminWebVitalsRoute = AdminWebVitalsRouteImport.update({
            id: '/admin/web-vitals',path: '/admin/web-vitals',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ByIndexRoute = ByIndexRouteImport.update({
            id: '/by/',path: '/by/',getParentRoute: () => rootRouteImport
          })
const ByAboutUsRoute = ByAboutUsRouteImport.update({
            id: '/by/about-us',path: '/by/about-us',getParentRoute: () => rootRouteImport
          })
const ByAgentRoute = ByAgentRouteImport.update({
            id: '/by/agent',path: '/by/agent',getParentRoute: () => rootRouteImport
          })
const ByContactRoute = ByContactRouteImport.update({
            id: '/by/contact',path: '/by/contact',getParentRoute: () => rootRouteImport
          })
const ByCookiePolicyRoute = ByCookiePolicyRouteImport.update({
            id: '/by/cookie-policy',path: '/by/cookie-policy',getParentRoute: () => rootRouteImport
          })
const ByInterimManagementRoute = ByInterimManagementRouteImport.update({
            id: '/by/interim-management',path: '/by/interim-management',getParentRoute: () => rootRouteImport
          })
const ByLibertyRoute = ByLibertyRouteImport.update({
            id: '/by/liberty',path: '/by/liberty',getParentRoute: () => rootRouteImport
          })
const ByMarketingSalesRoute = ByMarketingSalesRouteImport.update({
            id: '/by/marketing-sales',path: '/by/marketing-sales',getParentRoute: () => rootRouteImport
          })
const ByOctopusRoute = ByOctopusRouteImport.update({
            id: '/by/octopus',path: '/by/octopus',getParentRoute: () => rootRouteImport
          })
const ByPersonaFiRoute = ByPersonaFiRouteImport.update({
            id: '/by/personaFi',path: '/by/personaFi',getParentRoute: () => rootRouteImport
          })
const ByPrivacyPolicyRoute = ByPrivacyPolicyRouteImport.update({
            id: '/by/privacy-policy',path: '/by/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ByResearcherRoute = ByResearcherRouteImport.update({
            id: '/by/researcher',path: '/by/researcher',getParentRoute: () => rootRouteImport
          })
const CaseStudiesSpotlessPolskaRoute = CaseStudiesSpotlessPolskaRouteImport.update({
            id: '/case-studies/spotless-polska',path: '/case-studies/spotless-polska',getParentRoute: () => rootRouteImport
          })
const PersonaFiAgentRoute = PersonaFiAgentRouteImport.update({
            id: '/agent',path: '/agent',getParentRoute: () => PersonaFiRoute
          })
const PlIndexRoute = PlIndexRouteImport.update({
            id: '/pl/',path: '/pl/',getParentRoute: () => rootRouteImport
          })
const PlAboutUsRoute = PlAboutUsRouteImport.update({
            id: '/pl/about-us',path: '/pl/about-us',getParentRoute: () => rootRouteImport
          })
const PlAgentRoute = PlAgentRouteImport.update({
            id: '/pl/agent',path: '/pl/agent',getParentRoute: () => rootRouteImport
          })
const PlContactRoute = PlContactRouteImport.update({
            id: '/pl/contact',path: '/pl/contact',getParentRoute: () => rootRouteImport
          })
const PlCookiePolicyRoute = PlCookiePolicyRouteImport.update({
            id: '/pl/cookie-policy',path: '/pl/cookie-policy',getParentRoute: () => rootRouteImport
          })
const PlInterimManagementRoute = PlInterimManagementRouteImport.update({
            id: '/pl/interim-management',path: '/pl/interim-management',getParentRoute: () => rootRouteImport
          })
const PlLibertyRoute = PlLibertyRouteImport.update({
            id: '/pl/liberty',path: '/pl/liberty',getParentRoute: () => rootRouteImport
          })
const PlMarketingSalesRoute = PlMarketingSalesRouteImport.update({
            id: '/pl/marketing-sales',path: '/pl/marketing-sales',getParentRoute: () => rootRouteImport
          })
const PlOctopusRoute = PlOctopusRouteImport.update({
            id: '/pl/octopus',path: '/pl/octopus',getParentRoute: () => rootRouteImport
          })
const PlPersonaFiRoute = PlPersonaFiRouteImport.update({
            id: '/pl/personaFi',path: '/pl/personaFi',getParentRoute: () => rootRouteImport
          })
const PlPrivacyPolicyRoute = PlPrivacyPolicyRouteImport.update({
            id: '/pl/privacy-policy',path: '/pl/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PlResearcherRoute = PlResearcherRouteImport.update({
            id: '/pl/researcher',path: '/pl/researcher',getParentRoute: () => rootRouteImport
          })
const ByBlogIndexRoute = ByBlogIndexRouteImport.update({
            id: '/by/blog/',path: '/by/blog/',getParentRoute: () => rootRouteImport
          })
const ByBlogSlugRoute = ByBlogSlugRouteImport.update({
            id: '/by/blog/$slug',path: '/by/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ByCaseStudiesSpotlessPolskaRoute = ByCaseStudiesSpotlessPolskaRouteImport.update({
            id: '/by/case-studies/spotless-polska',path: '/by/case-studies/spotless-polska',getParentRoute: () => rootRouteImport
          })
const ByPersonaFiAgentRoute = ByPersonaFiAgentRouteImport.update({
            id: '/agent',path: '/agent',getParentRoute: () => ByPersonaFiRoute
          })
const PlBlogIndexRoute = PlBlogIndexRouteImport.update({
            id: '/pl/blog/',path: '/pl/blog/',getParentRoute: () => rootRouteImport
          })
const PlBlogSlugRoute = PlBlogSlugRouteImport.update({
            id: '/pl/blog/$slug',path: '/pl/blog/$slug',getParentRoute: () => rootRouteImport
          })
const PlCaseStudiesSpotlessPolskaRoute = PlCaseStudiesSpotlessPolskaRouteImport.update({
            id: '/pl/case-studies/spotless-polska',path: '/pl/case-studies/spotless-polska',getParentRoute: () => rootRouteImport
          })
const PlPersonaFiAgentRoute = PlPersonaFiAgentRouteImport.update({
            id: '/agent',path: '/agent',getParentRoute: () => PlPersonaFiRoute
          })





const PersonaFiRouteChildren = {
  PersonaFiAgentRoute: PersonaFiAgentRoute
}

const PersonaFiRouteWithChildren = PersonaFiRoute._addFileChildren(PersonaFiRouteChildren)




const ByPersonaFiRouteChildren = {
  ByPersonaFiAgentRoute: ByPersonaFiAgentRoute
}

const ByPersonaFiRouteWithChildren = ByPersonaFiRoute._addFileChildren(ByPersonaFiRouteChildren)




const PlPersonaFiRouteChildren = {
  PlPersonaFiAgentRoute: PlPersonaFiAgentRoute
}

const PlPersonaFiRouteWithChildren = PlPersonaFiRoute._addFileChildren(PlPersonaFiRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutUsRoute: AboutUsRoute,AgentRoute: AgentRoute,ContactRoute: ContactRoute,CookiePolicyRoute: CookiePolicyRoute,InterimManagementRoute: InterimManagementRoute,LibertyRoute: LibertyRoute,MarketingSalesRoute: MarketingSalesRoute,OctopusRoute: OctopusRoute,PersonaFiRoute: PersonaFiRouteWithChildren,PrivacyPolicyRoute: PrivacyPolicyRoute,ResearcherRoute: ResearcherRoute,AdminWebVitalsRoute: AdminWebVitalsRoute,BlogSlugRoute: BlogSlugRoute,ByAboutUsRoute: ByAboutUsRoute,ByAgentRoute: ByAgentRoute,ByContactRoute: ByContactRoute,ByCookiePolicyRoute: ByCookiePolicyRoute,ByInterimManagementRoute: ByInterimManagementRoute,ByLibertyRoute: ByLibertyRoute,ByMarketingSalesRoute: ByMarketingSalesRoute,ByOctopusRoute: ByOctopusRoute,ByPersonaFiRoute: ByPersonaFiRouteWithChildren,ByPrivacyPolicyRoute: ByPrivacyPolicyRoute,ByResearcherRoute: ByResearcherRoute,CaseStudiesSpotlessPolskaRoute: CaseStudiesSpotlessPolskaRoute,PlAboutUsRoute: PlAboutUsRoute,PlAgentRoute: PlAgentRoute,PlContactRoute: PlContactRoute,PlCookiePolicyRoute: PlCookiePolicyRoute,PlInterimManagementRoute: PlInterimManagementRoute,PlLibertyRoute: PlLibertyRoute,PlMarketingSalesRoute: PlMarketingSalesRoute,PlOctopusRoute: PlOctopusRoute,PlPersonaFiRoute: PlPersonaFiRouteWithChildren,PlPrivacyPolicyRoute: PlPrivacyPolicyRoute,PlResearcherRoute: PlResearcherRoute,BlogIndexRoute: BlogIndexRoute,ByIndexRoute: ByIndexRoute,PlIndexRoute: PlIndexRoute,ByBlogSlugRoute: ByBlogSlugRoute,ByCaseStudiesSpotlessPolskaRoute: ByCaseStudiesSpotlessPolskaRoute,PlBlogSlugRoute: PlBlogSlugRoute,PlCaseStudiesSpotlessPolskaRoute: PlCaseStudiesSpotlessPolskaRoute,ByBlogIndexRoute: ByBlogIndexRoute,PlBlogIndexRoute: PlBlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)